/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SuperpowerResponse = {
    id: string;
    user_id: string;
    question_index: number;
    question_category?: SuperpowerResponse.question_category | null;
    question_title: string;
    question_text: string;
    answer?: string | null;
    /**
     * Type of questionnaire (superpower, personality, or expertise)
     */
    questionnaire_type: SuperpowerResponse.questionnaire_type;
    /**
     * Unique ID for this attempt/version
     */
    attempt_id: string;
    /**
     * Whether this is the current version of the response
     */
    is_current: boolean;
    created_at: string;
    updated_at: string;
};
export namespace SuperpowerResponse {
    export enum question_category {
        EXPERTISE = 'expertise',
        NICHES = 'niches',
        IDEAL_REQUEST = 'ideal_request',
        FEAR = 'fear',
        DESIRE = 'desire',
        MECHANISM = 'mechanism',
        TRANSFORMATION = 'transformation',
        CLIENT_GREEN = 'client_green',
        CLIENT_RED = 'client_red',
        HISTORY = 'history',
        VALUES = 'values',
        PERSONA = 'persona',
        NICHE = 'niche',
        IDEAS = 'ideas',
        EMOTIONS = 'emotions',
        STRENGTHS = 'strengths',
        GROWTH = 'growth',
        INTERESTS = 'interests',
        CONTEXT = 'context',
        FACTS = 'facts',
        INSPIRATION = 'inspiration',
        ATTITUDE = 'attitude',
        PAST = 'past',
        PRESENT_FUTURE = 'present_future',
        PERSONALITY_VALUES = 'personality_values',
        AUTHORSHIP = 'authorship',
        COMMUNICATION = 'communication',
        MARKET = 'market',
    }
    /**
     * Type of questionnaire (superpower, personality, or expertise)
     */
    export enum questionnaire_type {
        SUPERPOWER = 'superpower',
        PERSONALITY = 'personality',
        EXPERTISE = 'expertise',
    }
}

